import { CartState } from '../types';
import appStore from '../utils/state';

export default class GiftProgressBar extends HTMLElement {
  private titleEl: HTMLParagraphElement | null = null;
  private subtitleEl: HTMLParagraphElement | null = null;
  private amountEl: HTMLSpanElement | null = null;
  private fillEl: HTMLDivElement | null = null;

  private unsubscribeFromCartUpdated: (() => void) | null = null;
  private onCartUpdatedBound = this.onCartUpdated.bind(this);

  connectedCallback(): void {
    this.titleEl = this.querySelector('[data-gift-progress-ref="title"]');
    this.subtitleEl = this.querySelector('[data-gift-progress-ref="subtitle"]');
    this.amountEl = this.querySelector('[data-gift-progress-ref="amount"]');
    this.fillEl = this.querySelector('[data-gift-progress-ref="fill"]');

    this.subscribe();
  }

  subscribe(): void {
    this.unsubscribeFromCartUpdated = appStore.subscribeKey('cart', this.onCartUpdatedBound);
  }

  unsubscribe(): void {
    if (this.unsubscribeFromCartUpdated) {
      this.unsubscribeFromCartUpdated();
      this.unsubscribeFromCartUpdated = null;
    }
  }

  onCartUpdated(cart: CartState): void {
    const nextBar = cart.data?.drawerSection?.querySelector('gift-progress-bar');

    if (!nextBar) {
      return;
    }

    this.dataset.threshold = nextBar.getAttribute('data-threshold') ?? '';
    this.dataset.remaining = nextBar.getAttribute('data-remaining') ?? '';
    this.dataset.progress = nextBar.getAttribute('data-progress') ?? '';
    this.dataset.unlocked = nextBar.getAttribute('data-unlocked') ?? 'false';

    if (this.titleEl) {
      this.titleEl.textContent = nextBar.querySelector('[data-gift-progress-ref="title"]')?.textContent ?? '';
    }

    if (this.subtitleEl) {
      this.subtitleEl.textContent = nextBar.querySelector('[data-gift-progress-ref="subtitle"]')?.textContent ?? '';
    }

    if (this.amountEl) {
      this.amountEl.textContent = nextBar.querySelector('[data-gift-progress-ref="amount"]')?.textContent ?? '';
    }

    if (this.fillEl) {
      const nextFill = nextBar.querySelector('[data-gift-progress-ref="fill"]') as HTMLDivElement | null;
      if (nextFill) {
        this.fillEl.style.transform = nextFill.style.transform;
      }
    }
  }

  disconnectedCallback(): void {
    this.unsubscribe();
  }
}

customElements.define('gift-progress-bar', GiftProgressBar);
